import PropTypes from "prop-types";
import { connect } from "react-redux";
import PaymentContact from "app/pages/Booking/Payment/PaymentContact";
import { bindActionCreators } from "redux";
import { getProfile } from "app/pages/Account/Profile/profileActionCreators";
import { PROFILE_CODE_STATUS } from "app/constants";
import withRouter from "app/utils/hocs/withRouter";
import { getCurrentShop } from "app/reducers/shopSelector";
import { shouldGetProfileAtPayment } from "app/pages/Account/Profile/profileSelector";
import usePrevious from "app/utils/hooks/usePrevious";
import { useCallback, useEffect } from "react";
import { updateBooking } from "app/pages/Booking/bookingActionCreators";

const PaymentContactContainer = props => {
	const { token, getProfile } = props;

	const prevToken = usePrevious(token);

	const fetchProfile = useCallback(() => {
		if (props.shouldGetProfileAtPayment) {
			getProfile().then(() => {
				if (typeof props.onFetchProfilSuccess === "function") {
					props.onFetchProfilSuccess();
				}
			});
		}
	}, [props.shouldGetProfileAtPayment, props.onFetchProfilSuccess]);

	useEffect(() => {
		fetchProfile();
	}, []);

	useEffect(() => {
		if (token && prevToken !== token) {
			fetchProfile();
		}
	}, [token, prevToken, fetchProfile]);

	return <PaymentContact {...props} />;
};

PaymentContactContainer.propTypes = {
	onFetchProfilSuccess: PropTypes.func,
	getProfile: PropTypes.func,
	token: PropTypes.string,
	shouldGetProfileAtPayment: PropTypes.bool,
};

const mapStateToProps = state => {
	const bookingContact = state.booking?.contact;
	const profile = state.profile;

	return {
		strategy: state.partner.strategy,
		token: state.auth.token,
		shop: getCurrentShop(state),
		isLoading: state.profile.status === PROFILE_CODE_STATUS.LOADING,
		shouldFetchProfile: shouldGetProfileAtPayment(state),
		countryName: bookingContact ? bookingContact?.address?.country : profile?.address?.country,
	};
};

const mapDispatchToProps = dispatch => {
	return bindActionCreators({ getProfile, updateBooking }, dispatch);
};

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(withRouter(PaymentContactContainer));
